import {
  ACTIVITY_TYPE_OPTIONS,
  findActivityTypeOption,
  findLegacyActivityCategoryOption,
  resolveActivityTaxonomy,
} from 'alakai-aloha-shared'

export const ACTIVITY_CATEGORY_FILTER_LABELS = ACTIVITY_TYPE_OPTIONS.map(
  ({title}) => title,
)

export function normalizeActivityDocument<T extends Record<string, any>>(activity: T): T & {
  category: string
  displayCategory?: string
  legacyCategory?: string
  legacyCategoryLabel?: string
  inventoryClass?: string
  inventoryClassLabel?: string
  activityType?: string
  activityTypeLabel?: string
  experienceTags: string[]
} {
  const taxonomy = resolveActivityTaxonomy(activity)
  const category = taxonomy.displayCategory || taxonomy.legacyCategoryLabel || ''

  return {
    ...activity,
    category,
    displayCategory: taxonomy.displayCategory || category || undefined,
    legacyCategory: taxonomy.legacyCategory || undefined,
    legacyCategoryLabel: taxonomy.legacyCategoryLabel || undefined,
    inventoryClass: taxonomy.inventoryClass || undefined,
    inventoryClassLabel: taxonomy.inventoryClassLabel || undefined,
    activityType: taxonomy.activityType || undefined,
    activityTypeLabel: taxonomy.activityTypeLabel || undefined,
    experienceTags: [...taxonomy.experienceTags],
  }
}

export function normalizeActivityDocuments<T extends Record<string, any>>(activities: T[] | null | undefined) {
  return Array.isArray(activities) ? activities.map((activity) => normalizeActivityDocument(activity)) : []
}

export function resolveActivityCategoryFilterLabel(value: string | null | undefined) {
  const activityTypeOption = findActivityTypeOption(value)
  if (activityTypeOption) return activityTypeOption.title

  const legacyCategoryOption = findLegacyActivityCategoryOption(value)
  if (legacyCategoryOption) {
    return resolveActivityTaxonomy({ legacyCategory: legacyCategoryOption.value }).displayCategory || legacyCategoryOption.title
  }

  return String(value || '').trim()
}
